import { useMutation, useQueryClient } from "react-query";
import { API_PATH } from "../utils/config";
import API from "./request";

export const useLogin = () => {
  return useMutation((data) => API.post(API_PATH.LOGIN, data));
};

export const useLogout = () => {
  return useMutation((data) => API.post(API_PATH.LOGOUT, data));
};

export const useSignup = () => {
  return useMutation((data) => API.post(API_PATH.SIGN_UP, data));
};

export const useVerifyEmailLink = () => {
  return useMutation((data) => API.post(API_PATH.VERIFY_EMAIL_LINK, data));
};

export const useResendVerificationLink = () => {
  return useMutation((data) =>
    API.post(API_PATH.RESEND_VERIFICATION_LINK, data)
  );
};

export const useDiscountPromoCode = () => {
  return useMutation((data) => API.post(API_PATH.DISCOUNT_CODE, data));
};

export const useVerifyEmailOtp = () => {
  return useMutation((data) => API.post(API_PATH.VERIFY_EMAIL_OTP, data));
};

export const useVerifyPhoneOtp = () => {
  return useMutation((data) => API.post(API_PATH.VERIFY_PHONE_OTP, data));
};

export const useSendEmailOtp = () => {
  return useMutation((data) => API.post(API_PATH.SEND_EMAIL_OTP, data));
};

export const useSendPhoneOtp = () => {
  return useMutation((data) => API.post(API_PATH.SEND_PHONE_OTP, data));
};

export const useForgotVerifyEmailOtp = () => {
  return useMutation((data) =>
    API.post(API_PATH.FORGOT_VERIFY_EMAIL_OTP, data)
  );
};

export const useForgotVerifyPhoneOtp = () => {
  return useMutation((data) =>
    API.post(API_PATH.FORGOT_VERIFY_PHONE_OTP, data)
  );
};

export const useForgotSendEmailOtp = () => {
  return useMutation((data) => API.post(API_PATH.FORGOT_SEND_EMAIL_OTP, data));
};

export const useForgotSendPhoneOtp = () => {
  return useMutation((data) => API.post(API_PATH.FORGOT_SEND_PHONE_OTP, data));
};

export const useVerifyPassword = () => {
  return useMutation((data) => API.post(API_PATH.VERIFY_PASSWORD, data));
};

export const useRemovePhone2fa = () => {
  return useMutation((data) => API.post(API_PATH.REMOVE_PHONE_2FA, data));
};

export const useResetPassword = () => {
  return useMutation((data) => API.post(API_PATH.RESET_PASSWORD, data));
};

export const useSubmitFeedback = () => {
  return useMutation((data) => API.post(API_PATH.SUBMIT_FEEDBACK, data));
};

export const useCreateWheel = () => {
  return useMutation((data) => API.post(API_PATH.CREATE_WHEEL, data));
};

export const useUpdateWheel = (wheelID) => {
  return useMutation((data) => API.put(API_PATH.EDIT_WHEEL(wheelID), data));
};

export const useUpdateWheelAfterCreate = () => {
  return useMutation((data) => API.put(API_PATH.EDIT_WHEEL(data.id), data));
};

export const useDeleteWheel = () => {
  return useMutation((data) =>
    API.delete(API_PATH.DELETE_WHEEL(data.wheelID), data)
  );
};

export const useUpdatePrimaryWheel = (wheelID) => {
  return useMutation((wheelID) => {
    return API.post(API_PATH.UPDATE_PRIMARY_WHEEL(wheelID), {});
  });
};

export const useUpdateWheelVisibility = (wheelID) => {
  return useMutation((wheelID) => {
    return API.post(API_PATH.UPDATE_WHEEL_VISIBILITY(wheelID), {});
  });
};

export const useUpdateWheelVisibilityV2 = () => {
  return useMutation((data) => {
    return API.post(API_PATH.UPDATE_WHEEL_VISIBILITY_V2(data?.wheelId), data);
  });
};

export const useRemovePrimaryWheel = () => {
  return useMutation(() => {
    return API.post(API_PATH.REMOVE_PRIMARY_WHEEL);
  });
};

export const useClonedWheel = () => {
  return useMutation((data) => {
    return API.post(API_PATH.CLONE_WHEEL(data?.wheelId), data);
  });
};

export const useCloneWheel = () => {
  return useMutation((data) => {
    return API.post(API_PATH.CLONE_WHEEL(data?.wheelId), data);
  });
};

export const useUploadWheelImage = () => {
  return useMutation((data) =>
    API.put(
      API_PATH.UPLOAD_WHEEL_IMAGE(data.wheelId),
      { wheel_image: data.wheel_image },
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    )
  );
};

export const useSaveExternalImage = () => {
  return useMutation((data) => API.post(API_PATH.SAVE_EXTERNAL_IMAGE(), data));
};

export const useUserUpdateProfile = () => {
  return useMutation((data) => API.patch(API_PATH.USER_UPDATE_PROFILE, data));
};

export const useCreateBusinessBoxV2 = () => {
  return useMutation((data) => API.post(API_PATH.CREATE_BUSINESSBOXV2, data));
};

export const useGetBusinessBoxV2 = (userId) => {
  return useMutation((data) =>
    API.get(API_PATH.GET_BUSINESSBOXV2(data.userid), data)
  );
};

export const useGoogleToken = () => {
  return useMutation((data) => API.post(API_PATH.GOOGLE_LOGIN, data));
};

export const useFacebook = () => {
  return useMutation((data) => API.post(API_PATH.FACEBOOK_LOGIN, data));
};

export const usePurchaseSubscription = () => {
  return useMutation((data) => API.post(API_PATH.PURCHASE_SUBSCRIPTION, data));
};

export const useChangeSubscription = () => {
  return useMutation((data) => API.post(API_PATH.CHANGE_SUBSCRIPTION, data));
};

export const useCancelSubscription = () => {
  return useMutation((data) => API.post(API_PATH.CANCEL_SUBSCRIPTION, data));
};

export const useCancelScheduledSubscriptionChange = () => {
  return useMutation(() =>
    API.post(API_PATH.CANCEL_SCHEDULED_SUBSCRIPTION_CHANGE)
  );
};

export const useRemoveCard = () => {
  return useMutation((data) => API.post(API_PATH.DELETE_CARD, data));
};

export const useAddCard = () => {
  return useMutation((data) => API.post(API_PATH.ADD_CARD, data));
};

export const useSetDefaultCard = () => {
  return useMutation((data) => API.post(API_PATH.SET_DEFAULT_CARD, data));
};

export const useChangePassword = () => {
  return useMutation((data) => API.put(API_PATH.CHANGE_PASSWORD, data));
};

export const useFeedback = () => {
  return useMutation((data) =>
    API.post(API_PATH.SEND_FEEDBACK(data.user_id), data)
  );
};

export const useCreateBusinessBox = () => {
  return useMutation((data) => API.post(API_PATH.CREATE_BUSINESSBOX, data));
};

export const useCreateBusinessBoxProfile = () => {
  return useMutation((data) =>
    API.post(API_PATH.UPDATE_BUSINESSBOX_PROFILE(data.id), data)
  );
};

export const useGetBusinessBox = () => {
  return useMutation((data) =>
    API.get(API_PATH.GET_BUSINESSBOX(data.userid), data)
  );
};

export const useUpdatBusinessBox = () => {
  return useMutation((data) =>
    API.put(API_PATH.UPDATE_BUSINESSBOX(data.id), data)
  );
};

export const useUpdateBusinessBoxV2 = () => {
  return useMutation((data) =>
    API.put(API_PATH.UPDATE_BUSINESSBOX_V2(data.id), data)
  );
};

export const useUpdatePrimaryBusinessBox = () => {
  return useMutation((data) =>
    API.post(API_PATH.UPDATE_PRIMARY_BUSINESSBOX(data.id), data)
  );
};

export const useDeleteBusinessBox = () => {
  return useMutation((data) =>
    API.delete(API_PATH.UPDATE_BUSINESSBOX(data.id), data)
  );
};

export const useDuplicateWheel = () => {
  return useMutation(
    (data) => API.post(API_PATH.DUPLICATE_WHEEL(data), data.data),
    {
      onSuccess: () => {
        // Refresh the page on successful mutation
        window.location.reload();
      },
    }
  );
};

export const useCloneSegment = () => {
  return useMutation((data) =>
    API.post(API_PATH.CLONE_SEGMENT(data.ActivityID), data.data)
  );
};

export const useGetPrivateWheelList = () => {
  return useMutation((data) =>
    API.get(
      API_PATH.GET_USER_PRIVATE_WHEELS_BY_ID(
        data.user_id,
        data.page,
        data.content
      ),
      data.data
    )
  );
};

export const usePostMediaBrowserData = () => {
  return useMutation((data) =>
    API.get(
      API_PATH.GET_MEDIA_BROWSER_DATA(
        data.text,
        data.type,
        data.source,
        data.page,
        data.per_page
      ),
      data.data
    )
  );
};

export const usePostMediaBrowserDataV2 = () => {
  return useMutation((data) =>
    API.get(
      API_PATH.GET_MEDIA_BROWSER_DATA_v2(
        data.text,
        data.type,
        data.source,
        data.page,
        data.per_page,
        data.offset, // Include offset if available
        data.limit // Include limit if available
      ),
      data.data
    )
  );
};

export const useGetUnlockWheelList = () => {
  return useMutation((data) =>
    API.get(
      API_PATH.GET_USER_UNLOCKED_WHEELS_BY_ID(
        data.user_id,
        data.page,
        data.content
      ),
      data.data
    )
  );
};

export const useGetClonedWheelList = () => {
  return useMutation((data) =>
    API.get(
      API_PATH.GET_USER_CLONED_WHEELS_BY_ID(
        data.user_id,
        data.page,
        data.content
      ),
      data.data
    )
  );
};

export const useGetClonedSegmentsList = () => {
  return useMutation((data) =>
    API.get(
      API_PATH.GET_USER_CLONED_SEGMENTS_BY_ID(data.page, data.content),
      data.data
    )
  );
};

export const useAutoGenerateWheel = () => {
  return useMutation((data) => API.post(API_PATH.AUTO_GENERATE_WHEEL, data));
};

export const useGenerateAiWheel = () => {
  return useMutation((data) => API.post(API_PATH.GENERATE_AI_WHEEL, data));
};

export const useAIGeneratedText = () => {
  return useMutation((data) => API.post(API_PATH.GENERATE_AI_TEXT, data));
};

export const useReferralsInvite = () => {
  return useMutation((data) => API.post(API_PATH.REFERRAL_INVITES, data));
};

export const usePaymentWithdraw = () => {
  return useMutation((data) => API.post(API_PATH.PAYMENT_WITHDRAW, data));
};

export const useConnectStripeAccount = () => {
  return useMutation(() => API.post(API_PATH.CONNECT_STRIPE, {}));
};

const unlockWheel = async ({ wheelId, accessCode }) => {
  const body = {
    lock_type: 2,
    access_code: accessCode,
  };
  return API.post(API_PATH.UNLOCK_WHEEL(wheelId), body);
};

export const useUnlockWheel = () => {
  return useMutation(unlockWheel);
};

export const useCreateWheelV2 = () => {
  return useMutation((data) => API.post(API_PATH.CREATE_WHEEL_V2, data));
};

export const useUpdateWheelV2 = (id) => {
  return useMutation((data) => API.put(API_PATH.UPDATE_WHEEL_V2(id), data));
  // if (id)
};

export const useDeleteWheelV2 = () => {
  return useMutation((id) => API.delete(API_PATH.DELETE_WHEEL_V2(id)));
};

export const useFavoriteWheel = () => {
  return useMutation((id) => API.post(API_PATH.FAVORITE_WHEEL(id)));
};

export const useUnlockWheelV2 = () => {
  return useMutation(({ wheelId, ...rest }) =>
    API.post(API_PATH.UNLOCK_WHEEL_V2(wheelId), { ...rest })
  );
};

export const useGetSuggestedColorPalette = (options = {}) => {
  return useMutation({
    mutationFn: (payload) =>
      API.post(API_PATH.GET_SUGGESTED_COLOR_PALETTE, payload),
    onSuccess: (data) => {
      if (options?.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (err) => {},
  });
};
export const useCreateFolder = () => {
  return useMutation((data) => API.post(API_PATH.CREATE_FOLDER, data));
};

export const useStoreEmailReferralCode = () => {
  return useMutation((data) =>
    API.post(API_PATH.STORE_EMAIL_REFERRAL_CODE, data)
  );
};
export const useUpdateFolder = () => {
  return useMutation((data) => {
    const { id, ...restData } = data;
    return API.patch(API_PATH.UPDATE_FOLDER(id), restData);
  });
};

export const useDeleteFolder = () => {
  return useMutation((id) => API.delete(API_PATH.DELETE_FOLDER(id)));
};

export const useMoveFolder = () => {
  return useMutation((data) => {
    const { destinationId, wheel_id, folder_to_move } = data;
    const payload = wheel_id ? { wheel_id } : { folder_to_move };
    return API.put(API_PATH.MOVE_ITEM(destinationId), payload);
  });
};

export const useRemoveWheelFromFolder = () => {
  return useMutation(({ folder_id, ...rest }) =>
    API.put(API_PATH.REMOVE_WHEEL(folder_id), rest)
  );
};

export const useBroadcastChanges = () => {
  return useMutation((wheelId) => API.put(API_PATH.BROADCAST_CHANGES(wheelId)));
};
export const useSubmitReport = () => {
  return useMutation((data) => API.post(API_PATH.SUBMIT_REPORT, data));
};

export const useAddEmails = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ wheelId, emails }) => {
      const response = await API.post(`${API_PATH.ADD_EMAILS(wheelId)}`, {
        emails,
      });
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("emailPermissions");
      },
      onError: (error) => {
        console.error("Failed to add emails:", error);
      },
    }
  );
};

export const useDeleteWheelEmailPermission = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ wheelId, emails }) => {
      const response = await API.post(
        API_PATH.DELETE_WHEEL_EMAIL_PERMISSION(wheelId),
        { emails }
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("emailPermissions");
      },
      onError: (error) => {
        console.error("Failed to delete email permission:", error);
      },
    }
  );
};

export const useSubmitDMCATakedown = () => {
  return useMutation((data) => API.post(API_PATH.DMCA_TAKEDOWN, data));
};

export const useSubmitDMCACounter = () => {
  return useMutation((data) => API.post(API_PATH.DMCA_COUNTER, data));
};

export const useSubmitContentRemovalDispute = () => {
  return useMutation((data) =>
    API.post(API_PATH.CONTENT_REMOVAL_DISPUTE, data)
  );
};

export const useToggleWheelActive = () => {
  return useMutation(
    (wheelId) => API.post(API_PATH.TOGGLE_WHEEL_ACTIVE(wheelId)),
    {
      onError: (error) => {
        console.error("Failed to toggle wheel active status:", error);
      },
    }
  );
};

export const useValidatePromoCode = (options = {}) => {
  return useMutation((data) => API.post(API_PATH.VALIDATE_PROMO_CODE, data), {
    onSuccess: (data) => {
      if (options?.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (error) => {
      if (options?.onError) {
        options.onError(error);
      }
    },
  });
};
